import { useMutation, useQueryClient } from '@tanstack/react-query';
import { acceptTos } from '../services/tosApi';
import { tosKeys } from './queryKeys';
/**
 * Mutation hook for recording TOS acceptance.
 *
 * On success, invalidates `tosKeys.status()` so `useTosStatusQuery` refetches
 * and `accepted` becomes true, automatically closing the TOS modal.
 *
 * On error, the mutation's `isError` / `error` state is exposed to callers
 * so the TosModal can surface a retry message without closing.
 */
export function useAcceptTosMutation() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: acceptTos,
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: tosKeys.status() });
        }
    });
}
